

















































































































































import { Watch, Component, Vue, Inject, Ref } from 'vue-property-decorator'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { TriggeredReferralAPI, RealworksKenmerkAPI } from '@/api/backend-client'
import { RealworksCredentials } from '@/api/model/credentials'
import { namespace } from 'vuex-class'
import CreateAutoLeadSideSheet from '@/components/virtual-colleague/auto-lead/CreateAutoLeadSideSheet.vue'
const triggeredReferral = namespace('triggeredReferral')

@Component
export default class CompanySettingsTriggeredReferral extends Vue {
    @triggeredReferral.State readonly loading!: boolean
    @triggeredReferral.State readonly triggeredReferrals!: TriggeredReferral[]
    @triggeredReferral.State readonly totalItems!: number
    @triggeredReferral.State readonly totalPages!: number
    @triggeredReferral.State readonly page!: number
    @triggeredReferral.State readonly orderField!: string | null
    @triggeredReferral.State readonly orderDirection!: string | null
    @triggeredReferral.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @triggeredReferral.Action nextPage: () => Promise<void>
    @triggeredReferral.Action prevPage: () => Promise<void>
    @triggeredReferral.Action applyOrder: ({field, direction}) => Promise<void>
    @Inject() readonly reloadCompany: () => Promise<void>
    @Ref() autoLeadSideSheet: CreateAutoLeadSideSheet
    realworksKenmerken: any = {}

    created() {
        this.onRouteChange()
    }

    async reload() {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
        this.$forceUpdate()
    }

    @Watch('$route')
    async onRouteChange(): Promise<void> {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })

        await this.getKenmerken()
    }

    async goToTriggeredReferralDetail(triggered_referral: TriggeredReferral): Promise<void> {
        this.autoLeadSideSheet.openWithExisting(triggered_referral)
    }

    async goToTriggeredReferralCreate(): Promise<void> {
        this.autoLeadSideSheet.open()
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }

    async deleteTriggeredReferral(triggered_referral) {
        if (confirm(this.$t('company_settings.triggered_referrals.delete_confirm').toString())) {
            await TriggeredReferralAPI.delete(triggered_referral.id)
            await this.reloadCompany()
        }
    }

    async getKenmerken() {
        const realworksKenmerken = {}

        const kenmerken = await RealworksKenmerkAPI.getAll()
        for (const kenmerk of kenmerken) {
            realworksKenmerken[kenmerk.id] = kenmerk.omschrijving
        }

        this.realworksKenmerken = realworksKenmerken
    }

    realworksCredentialsLabel(realworksCredentials: RealworksCredentials|null): string {
        if (realworksCredentials) {
            return realworksCredentials.description
        }

        return this.$t('company_settings.triggered_referrals.header.realworksCredentials_all').toString()
    }

    realworksKenmerkLabel(realworksKenmerkId: string): string {
        if (this.realworksKenmerken[realworksKenmerkId]) {
            return `${realworksKenmerkId} - ${this.realworksKenmerken[realworksKenmerkId]}`
        }

        return `${realworksKenmerkId}`
    }
}
